module.exports = __webpack_public_path__ + "img/2018-12-16-5.3cc889d4.jpeg";